import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, IonicPage, Platform } from 'ionic-angular';

import { globalDefines, version } from '../../app/app.constants';
import { ConfigurationProvider } from '../../providers/configuration/configuration';
import { NotificationProvider } from '../../providers/notification/notification';


@IonicPage()
@Component({
  selector: 'page-configuration',
  templateUrl: 'configuration.html',
})
export class ConfigurationPage {

  checkReminder;
  checkReminderSubscription;

  version = version;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public configuration: ConfigurationProvider,
    public notificationProvider: NotificationProvider,
    public platform: Platform
  ) {
    this.checkReminderSubscription = this.notificationProvider.getCheckReminder().subscribe(option => this.checkReminder = option);
  }

  ionViewWillUnload() {
    if(this.checkReminderSubscription && !this.checkReminderSubscription.closed) this.checkReminderSubscription.unsubscribe();
  }

  registerDevice() {
    this.configuration.registerDevice().then((result: string) => {
      this.showMessage(result);
    }).catch(error => {
      this.showMessage(error);
    })
  }

  toggleCheckReminder() {
    this.notificationProvider.setCheckReminder(this.checkReminder);
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration.ts